import request from "@/utils/request";
const BASE_API = process.env.VUE_APP_BASE_API;
import {isProductionEnvironment } from '@/utils/index.js'

export function getPhone(param) {
    return request({
        url: `${BASE_API}/api/phone/setting`,
        method: "get",
        params: param,
    });
}

export function postNewChat(param){
  return request({
    url: `${BASE_API}/api/new`,
    method: "post",
    data: param
  })
}

export function postAskChat(param){
  return request({
    url: `${BASE_API}/api/ask`,
    method: "post",
    data: param
  })
}

export function postPay(param){
  return request({
    url: `${BASE_API}/api/pay`,
    method: "post",
    data: param
  })
}

export function postHistory(param){
  return request({
    url: `${BASE_API}/api/history`,
    method: "post",
    data: param
  })
}

export function postAnswer(param){
  return request({
    url: `${BASE_API}/api/answer`,
    method: "post",
    data: param
  })
}

export function postUserHistory(param){
  return request({
    url: `${BASE_API}/api/user_history`,
    method: 'post',
    data: param
  })
}

export function postDefaultQuestion(param){
  return request({
    url: `${BASE_API}/api/default_question`,
    method: 'post',
    data: param
  })
}

export function postDeleteConv(param){
  return request({
    url: `${BASE_API}/api/delete_conv`,
    method: 'post',
    data: param
  })
}

export function getHistoryCost(param) {
    return request({
        url: `${BASE_API}/api/history_cost`,
        method: "post",
        params: param,
    });
}

export function getAgentQrCode(url, param) {
    return request({
        // url: `https://radartest.mktindex.com/api/agent_qr_code`,
        url: url,
        method: "get",
        params: param,
    });
}

export function getPyoutParser(data) {
  const url = isProductionEnvironment() ? 'https://social.mktindex.com/api/pyout_parser' : 'https://socialtest.mktindex.com/api/pyout_parser'
  return request({
    url: url,
    method: "post",
    data: data,
  });
}

export function postInviteCode(param) {
    return request({
        url: `${BASE_API}/api/invite_code`,
        method: "post",
        data: param,
    });
}

export function postUserInviteList(param) {
    return request({
        url: `${BASE_API}/api/user_invite_list`,
        method: "post",
        data: param,
    });
}

export function postHistoryChargeList(param) {
    return request({
        url: `${BASE_API}/api/history_charge_list`,
        method: "post",
        data: param,
    });
}

export function clientError(data) {
	return request({
		url: `${BASE_API}/api/client_error`,
		method: 'post',
		data,
	})
}

export function getNoticeInfo(param) {
  return request({
    url: `${BASE_API}/api/server_status`,
    method: "get",
    params: param,
  });
}

export function postShareDoc(param) {
    return request({
        url: `${BASE_API}/api/share_doc`,
        method: "post",
        data: param,
    });
}

